import { render, staticRenderFns } from "./mallNavconfig.vue?vue&type=template&id=8f9c39f6&scoped=true"
import script from "./mallNavconfig.vue?vue&type=script&lang=js"
export * from "./mallNavconfig.vue?vue&type=script&lang=js"
import style0 from "./mallNavconfig.vue?vue&type=style&index=0&id=8f9c39f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9c39f6",
  null
  
)

export default component.exports